import React from "react";

const RequiredFieldMarker = () => {
  return (
    <div style={{ display: "inline-block", color: "red", paddingLeft: "2px" }}>
      *
    </div>
  );
};

export default RequiredFieldMarker;
